import React from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import Clock from "../assets/project/icones_apropos/Clock.svg";
import Client from "../assets/project/icones_apropos/friends.svg";
import Projet from "../assets/project/icones_apropos/projet.svg";
import Prix from "../assets/project/icones_apropos/Cup.svg";
import { Grid, Row, Col } from "react-flexbox-grid";

import "./style/nosprojets.css"

class NosProjets extends React.Component {
  state = {
    didViewCountUp: false
  };


  onVisibilityChange = isVisible => {

    if (isVisible) {
      this.setState({didViewCountUp: true});
    }
  }
  render() {
    return (
      <div className="banniereNosProject">
        <div className="titleHead">
          <h2 className="Title">Découvrez nos projets</h2>
        </div>

        <Grid fluid className="gridFluid">
        <Row>
          <Col xs={6} md={3} lg={3} style={{maxWidth: "100%"}}> 
            <div id="moncercle">
              <img style={{width: "30px",marginLeft: "auto", display: "block", marginTop: "30%",marginRight: "auto" }} src={Clock} alt="" />
            </div>
            <div style={{ padding: "20px",textAlign: "center"}}> 
              <VisibilitySensor onChange={this.onVisibilityChange} delayedCall>
                <CountUp className="ChiffreStyle" start={205000}   duration={6} end={this.state.didViewCountUp ? 212000 : 0}
                    />
              </VisibilitySensor>
            
              <p className="SousChiffre">HEURES DE <br/>TRAVAIL</p>
            </div> 
          </Col>
          <Col xs={6} md={3} lg={3} style={{maxWidth: "100%"}} > 
            <div id="moncercle">
              <img style={{width: "30px",marginLeft: "auto", display: "block", marginTop: "25%",marginRight: "auto" }} src={Client} alt="" />
            </div>
            <div style={{ padding: "20px",textAlign: "center"}}> 
              <VisibilitySensor onChange={this.onVisibilityChange} delayedCall>
                <CountUp className="ChiffreStyle" start={0}   duration={6} end={this.state.didViewCountUp ? 33 : 0}
                    />
              </VisibilitySensor>
           
              <p className="SousChiffre" >entreprises clientes <br/>satisfaites</p>
            </div>
          </Col>


          <Col xs={6} md={3} lg={3} style={{maxWidth: "100%"}}> 
            <div id="moncercle">
              <img style={{width: "30px",marginLeft: "auto", display: "block", marginTop: "25%",marginRight: "auto" }} src={Projet} alt="" />
            </div>
            <div style={{ padding: "20px",textAlign: "center"}}> 
              <VisibilitySensor onChange={this.onVisibilityChange} delayedCall>
                <CountUp className="ChiffreStyle" start={0}   duration={6} end={this.state.didViewCountUp ? 58 : 0}
                  />
              </VisibilitySensor>
            
              <p className="SousChiffre">projets <br/> délivrés</p>
            </div>
          </Col>

          <Col xs={6} md={3} lg={3} style={{maxWidth: "100%"}}> 
        
            <div id="moncercle">
              <img style={{width: "30px",marginLeft: "auto", display: "block", marginTop: "30%",marginRight: "auto" }} src={Prix} alt="" />
            </div>
            <div style={{ padding: "20px",textAlign: "center"}}> 
            <VisibilitySensor onChange={this.onVisibilityChange} delayedCall>
                <CountUp className="ChiffreStyle" start={0}   duration={6} end={this.state.didViewCountUp ? 14 : 0}
                    />
              </VisibilitySensor>
           
              <p className="SousChiffre">prix <br/>remportés</p>
            </div>
          </Col>
          </Row>
        </Grid>

      </div>

    );
  }
}
export default NosProjets;




// WEBPACK FOOTER //
// ./src/home/NosProjets.js